// Forge 2026 redesign: site-wide behavior ported from mockups/whe/site.js.
// The header and footer markup now come from Liquid sections; this file only adds behavior.
(function () {
  // Header sits over a photo hero, then turns solid. Pages without a hero start solid.
  var header = document.querySelector('[data-fs-header]');
  if (header) {
    var hero = document.querySelector('.fs .hero');
    if (!hero) document.body.classList.add('no-hero');
    // Shopify's own pages (cart, search, account, the spam check) have no redesign sections and
    // no top spacing of their own, so clear the fixed header by its real height, plus a little air.
    if (!hero && !document.querySelector('main .fs')) {
      var clearHeader = function () { document.body.style.paddingTop = header.offsetHeight + 24 + 'px'; };
      clearHeader();
      window.addEventListener('resize', clearHeader);
    }
    var updateHeader = function () {
      var solid = !hero || window.scrollY > hero.offsetHeight - 90;
      header.classList.toggle('is-solid', solid);
    };
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  // Phone menu
  var menu = document.querySelector('[data-menu]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  if (menu && openBtn && closeBtn) {
    openBtn.addEventListener('click', function () {
      menu.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      closeBtn.focus();
    });
    closeBtn.addEventListener('click', function () {
      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeBtn.click();
    });
  }

  // Accordion (Help)
  document.querySelectorAll('.fs .acc__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var open = q.parentElement.classList.toggle('is-open');
      q.setAttribute('aria-expanded', String(open));
    });
  });

  // Collection filter chips (Shop): hide cards and empty rows outside the chosen family
  var chips = document.querySelectorAll('.fs [data-filter]');
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var f = c.getAttribute('data-filter');
      chips.forEach(function (x) { x.classList.toggle('is-active', x === c); });
      var shown = 0;
      document.querySelectorAll('.fs [data-family]').forEach(function (card) {
        var show = f === 'all' || card.getAttribute('data-family') === f;
        card.style.display = show ? '' : 'none';
        if (show) shown++;
      });
      document.querySelectorAll('.fs .shelf').forEach(function (shelf) {
        var any = [].some.call(shelf.querySelectorAll('[data-family]'), function (card) { return card.style.display !== 'none'; });
        shelf.style.display = any ? '' : 'none';
      });
      var counter = document.querySelector('.fs [data-count]');
      if (counter) counter.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
    });
  });

  // Product page: finish and collection choices select a variant; price, total, sold-out state and
  // the cart form's variant ID follow it. Thumbnails swap the main photo.
  var pdp = document.querySelector('.fs [data-pdp]');
  if (pdp) {
    var variants = JSON.parse(pdp.querySelector('[data-variants]').textContent);
    var idInput = pdp.querySelector('[data-variant-id]');
    var qtyInput = pdp.querySelector('[data-qty-input]');
    var countOut = pdp.querySelector('[data-qty-count]');
    var priceOut = pdp.querySelector('[data-price-display]');
    var totalOut = pdp.querySelector('[data-total]');
    var submit = pdp.querySelector('[data-submit]');
    var submitLabel = pdp.querySelector('[data-submit-label]');
    var groups = [].slice.call(pdp.querySelectorAll('[data-option-index]'));

    var money = function (cents) {
      var n = cents / 100;
      return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    var selection = function () {
      return groups.map(function (g) {
        var b = g.querySelector('.is-active');
        return { index: +g.getAttribute('data-option-index'), value: b ? b.getAttribute('data-value') : null };
      });
    };
    var find = function (sel) {
      return variants.filter(function (v) {
        return sel.every(function (s) { return s.value === null || v.options[s.index] === s.value; });
      })[0];
    };

    var update = function () {
      // Grey out finishes that are sold out with the other choices as they stand
      groups.forEach(function (g, gi) {
        if (!g.hasAttribute('data-swatches')) return;
        g.querySelectorAll('button').forEach(function (b) {
          var sel = selection();
          sel[gi].value = b.getAttribute('data-value');
          var v = find(sel);
          var ok = !!(v && v.available);
          b.disabled = !ok;
          b.title = b.getAttribute('data-value') + (ok ? '' : ', ' + submit.getAttribute('data-sold-out').toLowerCase());
        });
        var active = g.querySelector('.is-active');
        if (active && active.disabled) {
          var open = g.querySelector('button:not(:disabled)');
          if (open) { active.classList.remove('is-active'); open.classList.add('is-active'); }
        }
      });
      groups.forEach(function (g) {
        var out = g.parentElement.querySelector('[data-option-value]');
        var b = g.querySelector('.is-active');
        if (out && b) out.textContent = b.getAttribute('data-value');
      });
      var v = find(selection());
      if (!v) return;
      var n = parseInt(countOut.textContent, 10);
      idInput.value = v.id;
      qtyInput.value = n;
      priceOut.textContent = money(v.price);
      pdp.querySelectorAll('[data-price-mirror]').forEach(function (el) { el.textContent = money(v.price); });
      totalOut.textContent = money(v.price * n);
      submit.disabled = !v.available;
      submitLabel.textContent = v.available ? submit.getAttribute('data-label') : submit.getAttribute('data-sold-out');
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      syncGallery();
    };

    // Finish gallery: show the picked finish's photos; lifestyle photos (data-finish="*") always stay.
    // A finish with no photo of its own yet shows the lifestyle photos only.
    var gallery = pdp.querySelector('[data-finish-gallery]');
    var lastKey = gallery ? gallery.getAttribute('data-current') : null;
    var syncGallery = function () {
      if (!gallery) return;
      var finish = null;
      var coll = null;
      groups.forEach(function (g) {
        var b = g.querySelector('.is-active');
        var val = b ? b.getAttribute('data-value') : null;
        if (g.hasAttribute('data-swatches')) finish = val; else coll = val;
      });
      var key = coll ? coll + ' / ' + finish : finish;
      if (key === lastKey) return;
      lastKey = key;
      var thumbs = [].slice.call(gallery.querySelectorAll('[data-finish]'));
      var own = thumbs.filter(function (t) { return t.getAttribute('data-finish') === key; });
      var life = thumbs.filter(function (t) { return t.getAttribute('data-finish') === '*'; });
      thumbs.forEach(function (t) {
        var f = t.getAttribute('data-finish');
        t.hidden = !(f === '*' || f === key);
      });
      var first = own[0] || life[0];
      if (first) first.click();
    };

    groups.forEach(function (g) {
      g.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          g.querySelectorAll('button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          update();
        });
      });
    });
    pdp.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(countOut.textContent, 10) + (b.getAttribute('data-step') === '+' ? 1 : -1);
        countOut.textContent = Math.min(20, Math.max(1, n));
        update();
      });
    });

    var main = pdp.querySelector('.pdp__main img');
    // The main photo starts with the product name as its description; a thumbnail brings its own
    var mainAlt = main ? main.alt : '';
    pdp.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) {
          main.srcset = t.getAttribute('data-srcset');
          main.src = t.getAttribute('data-thumb');
          main.style.objectPosition = t.getAttribute('data-pos') || '';
          main.alt = t.getAttribute('data-alt') || mainAlt;
        }
        pdp.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  // OSTE issues (Substack): the latest issue fills the large block and the next three a row of cards,
  // read from the OSTE feed relay. If the feed can't be reached, the fallback link to Substack stays.
  document.querySelectorAll('.fs [data-oste-feed]').forEach(function (box) {
    var https = function (u) { return /^https:\/\//.test(u || ''); };
    var cdn = function (src, w) {
      return 'https://substackcdn.com/image/fetch/w_' + w + ',c_limit,f_auto,q_auto:good/' + encodeURIComponent(src);
    };
    var setImage = function (img, src, sizes) {
      img.srcset = [600, 1000, 1400, 2000].map(function (w) { return cdn(src, w) + ' ' + w + 'w'; }).join(', ');
      img.sizes = sizes;
      img.src = cdn(src, 1400);
      img.alt = '';
    };
    var day = function (iso) {
      return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/Los_Angeles' });
    };
    fetch(box.getAttribute('data-oste-feed'))
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (data) {
        var items = ((data && data.items) || []).filter(function (i) { return https(i.url); });
        if (!items.length) return;
        // "Issue N° 01" with the subtitle "The Plate Comes First" reads "Latest issue · N° 01" over the subtitle
        var latest = items[0];
        var label = box.getAttribute('data-latest-label');
        var number = latest.title.replace(/^issue\s+/i, '');
        box.querySelector('[data-oste-label]').textContent = latest.subtitle ? label + ' · ' + number : label;
        box.querySelector('[data-oste-title]').textContent = latest.subtitle || latest.title;
        var date = box.querySelector('[data-oste-date]');
        if (latest.date) { date.textContent = day(latest.date); date.hidden = false; }
        box.querySelector('[data-oste-link]').href = latest.url;
        if (https(latest.image)) {
          var img = box.querySelector('.issue__img');
          if (!img) {
            img = document.createElement('img');
            img.className = 'issue__img';
            box.querySelector('.issue').insertBefore(img, box.querySelector('.issue__text'));
          }
          setImage(img, latest.image, '(max-width: 1000px) 100vw, 55vw');
        }
        var earlier = items.slice(1, 4);
        if (!earlier.length) return;
        var grid = box.querySelector('[data-oste-grid]');
        earlier.forEach(function (item) {
          var card = document.createElement('a');
          card.className = 'card';
          card.href = item.url;
          card.target = '_blank';
          card.rel = 'noopener';
          if (https(item.image)) {
            var photo = document.createElement('div');
            photo.className = 'card__photo';
            var pic = document.createElement('img');
            pic.loading = 'lazy';
            setImage(pic, item.image, '(max-width: 1000px) 100vw, 33vw');
            photo.appendChild(pic);
            card.appendChild(photo);
          }
          var tag = document.createElement('span');
          tag.className = 'label';
          tag.textContent = item.title;
          card.appendChild(tag);
          if (item.subtitle) {
            var name = document.createElement('p');
            name.className = 'card__name';
            name.textContent = item.subtitle;
            card.appendChild(name);
          }
          grid.appendChild(card);
        });
        box.querySelector('[data-oste-earlier]').hidden = false;
      })
      .catch(function () {})
      .then(function () { box.classList.remove('is-loading'); });
  });

  // Sort (Shop): reorder cards within each row by price; Featured restores the original order
  document.querySelectorAll('.fs [data-sort]').forEach(function (select) {
    var grids = document.querySelectorAll('.fs .shelf .grid');
    grids.forEach(function (grid) {
      [].forEach.call(grid.children, function (card, i) { card.setAttribute('data-index', i); });
    });
    select.addEventListener('change', function () {
      grids.forEach(function (grid) {
        var cards = [].slice.call(grid.children);
        cards.sort(function (a, b) {
          if (select.value === 'featured') return a.getAttribute('data-index') - b.getAttribute('data-index');
          var diff = a.getAttribute('data-price') - b.getAttribute('data-price');
          return select.value === 'price-desc' ? -diff : diff;
        });
        cards.forEach(function (card) { grid.appendChild(card); });
      });
    });
  });
})();
